import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledBabaSaleBadge = styled.div<{ badgeOutline: boolean }>`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1;
  right: ${({ badgeOutline }) => (badgeOutline ? '-4px' : '-1px')};
  top: ${({ badgeOutline }) => (badgeOutline ? '-4px' : '-1px')};

  img {
    width: 100%;
    height: 100%;
  }
` as any;

export const StyledBabaSaleBadgeNumber = styled.div`
  position: absolute;
  left: 50%;
  bottom: 21%;
  transform: translateX(-50%);
  color: #fdf7d2;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: none;
  text-align: center;
` as any;
